
import { Injectable } from '@angular/core';
import { Firestore } from '@angular/fire/firestore';
import { FirestoreService } from './firestore.service';
import { Profile } from 'src/app/profile/profile.model';

@Injectable({
  providedIn: 'root'
})


export class ProfileFirestoreService extends FirestoreService<Profile> {
  public basePath = '';
  constructor(firestore: Firestore) {
    super(firestore);
  }
}
